import _defineProperty from 'babel-runtime/helpers/defineProperty';

import _ from 'lodash';

export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    var _marks;

    this.value = _.get(this.model, this.config.prop);
    this.step = _.get(this.config.field, 'step');
    this.step = typeof this.step === 'undefined' ? 1 : this.step;
    this.min = _.get(this.config.field, 'min');
    this.min = typeof this.min === 'undefined' ? 0 : this.min;
    this.max = _.get(this.config.field, 'max');
    this.max = typeof this.max === 'undefined' ? 10 : this.max;
    this.marks = (_marks = {}, _defineProperty(_marks, this.min, this.min.toString()), _defineProperty(_marks, this.max, this.max.toString()), _marks);
  },
  data: function data() {
    return {
      step: 1,
      min: 0,
      max: 10,
      value: 0,
      marks: {}
    };
  },

  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    changeHandler: function changeHandler(v) {
      var prop = this.realProp();
      _.set(this.model.script, prop, Number(v));
      _.set(this.model, this.config.prop, Number(v));
    }
  }
};